<template>
  <div class="l-edit-dialog-box">
    <el-form
      :model="form_data"
      label-width="80px"
      ref="form"
      :rules="rules"
      label-position="left"
      v-loading="loading"
    >
      <el-form-item label="标题" prop="title">
        <el-input
          v-model="form_data.title"
          autocomplete="off"
          placeholder="请输入标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-radio-group v-model="form_data.state">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发送对象" prop="send_type" v-if="company_type == 2">
        <el-radio-group v-model="form_data.send_type">
          <el-radio :label="4">全部</el-radio>
          <el-radio :label="2">内部员工</el-radio>
          <el-radio :label="3">维修服务商</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="公告内容" prop="content">
        <!-- <el-input
          v-model="form_data.content"
          autocomplete="off"
          placeholder="请输入公告内容"
          type="textarea"
          :rows="4"
        ></el-input>-->
        <div ref="editorElem"></div>
      </el-form-item>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting"
        >确 定</el-button
      >
    </div>
  </div>
</template>

<script> 
import E from "wangeditor";
export default {
  name: "l-msg-main-edit",
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    visible: {
      type: Boolean,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      value: "",
      loading: false,
      submitting: false,
      form_data: {
        title: "",
        content: "",
        state: 1,
        send_type: 4,
      },
      company_type: 0,

      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "change" }],
        content: [
          { required: true, message: "请输入公告内容", trigger: "change" },
        ],
        state: [
          {
            type: "number",
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
        send_type: [
          {
            type: "number",
            required: true,
            message: "请选择发送对象",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    //初始化页面后加入富文本编辑器
    this.seteditor();
    this.editor.txt.html(this.value);
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      },
    },
    value: function (value) {
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
        console.log(this.value);
      }
    },
  },

  methods: {
    //富文本编辑器初始化
    seteditor() {
      const that = this;
      this.editor = new E(this.$refs.editorElem);
      this.editor.config.onchange = function () {
        that.form_data.content = that.editor.txt.html();
        console.log(that.editor.txt.html());
      };
      this.editor.create();
      this.editor.txt.html();
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },
    //获取添加数据
    getData() {
      if (this.hasId) {
        //编辑获取数据
        this.loading = true;
        this.$_invoke("msgMain_getEditData", { id: this.$props.id })
          .then((ret) => {
            this.form_data = ret.form_data;
            this.value = ret.form_data.content;
            this.company_type = ret.company_type;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        //添加获取数据
        this.loading = true;
        this.$_invoke("msgMain_getAddData", { id: this.$props.id })
          .then((ret) => {
            this.company_type = ret.company_type;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    //上传图标成功后的回调
    handleUploadIconSuccess(res) {
      this.form_data.img = res.data.img_url;
    },

    //提交数据
    handleSubmit() {
      const ftext = this.editor.txt.text().trim();
      if (this.loading) return;

      this.$refs.form.validate((valid) => {
        if (ftext !== "") {
          if (valid) {
            this.submitting = true;
            if (!this.hasId) {
              //添加
              this.$_invoke("msgMain_save", this.form_data)
                .then(() => {
                  this.$_msg.success("添加成功");
                  this.$emit("on-success");
                })
                .finally(() => {
                  this.submitting = false;
                });
            } else {
              //修改
              this.$_invoke(`msgMain_update`, this.form_data)
                .then(() => {
                  this.$_msg.success("修改成功");
                  this.$emit("on-success");
                })
                .finally(() => {
                  this.submitting = false;
                });
            }
          }
        }else{
          alert('请输入公告内容')
        }
      });
    },
  },
};
</script>